import { getApiProblemErrors } from "Infrastructure/Api/ApiUtils";
import { Resources } from "Translations/Resources";

const SCOPES = Resources.Sso.Scopes;
const ERRORS = Resources.Sso.Errors;

// What each OIDC/API scope means to the person, in their words. An unknown scope shows its raw name.
const SCOPE_RESOURCES: Record<string, string> = {
  openid: SCOPES.OpenId,
  profile: SCOPES.Profile,
  email: SCOPES.Email,
  offline_access: SCOPES.OfflineAccess,
  contexts: SCOPES.Contexts,
  payments: SCOPES.Payments,
  merchant: SCOPES.Merchant,
  hunter: SCOPES.Hunter,
  "terminals:manage": SCOPES.TerminalsManage,
  "directory:read": SCOPES.DirectoryRead,
  "coupons:create": SCOPES.CouponsCreate,
  "loyalty:read": SCOPES.LoyaltyRead,
};

export const getScopeResource = (scope: string): string | undefined =>
  SCOPE_RESOURCES[scope];

// openid is the protocol's own handshake, not something the person grants.
export const getGrantedScopes = (scopes: ReadonlyArray<string>) =>
  scopes.filter((scope) => scope !== "openid");

// The backend keys SSO failures by message code (`sso*`), stable across languages and HTTP statuses.
const ERROR_RESOURCES: Record<string, string> = {
  ssoRequestNotFound: ERRORS.RequestNotFound,
  ssoRequestExpired: ERRORS.RequestExpired,
  ssoRequestNotPending: ERRORS.RequestNotPending,
  ssoIdentityRequired: ERRORS.IdentityRequired,
  ssoIdentityNotActive: ERRORS.IdentityNotActive,
  ssoBackOfficeNotAllowed: ERRORS.BackOfficeNotAllowed,
  ssoConsentNotFound: ERRORS.ConsentNotFound,
  ssoClientNotFound: ERRORS.ClientNotFound,
};

export const getSsoErrorResource = (error: unknown): string => {
  const errors = getApiProblemErrors(error);
  const codes = Object.values(errors ?? {})
    .flat()
    .map((detail) => detail.message ?? "");
  const known = codes.find((code) => code in ERROR_RESOURCES);

  return known ? ERROR_RESOURCES[known] : ERRORS.Unknown;
};
